import { onboardingUnauthenticatedApi } from './_baseApi/onboarding.unauthenticated.base.api';
import { openBankingApi } from './openBankingApi/openBanking.api';
import { myPagesUnauthenticatedBaseApi } from './_baseApi/myPages.unauthenticated.base.api';
import { onboardingApi } from './onboardingApi/onboarding.api';
import { clientAssessmentApi } from './clientAssessmentApi/clientAssessment.api';
import { userManagementApi } from './userManagementApi/userManagement.api';

export const apis = {
  [myPagesUnauthenticatedBaseApi.reducerPath]:
    myPagesUnauthenticatedBaseApi.reducer,
  [onboardingUnauthenticatedApi.reducerPath]:
    onboardingUnauthenticatedApi.reducer,
  [openBankingApi.reducerPath]: openBankingApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
  [clientAssessmentApi.reducerPath]: clientAssessmentApi.reducer,
  [userManagementApi.reducerPath]: userManagementApi.reducer,
};
